import { useEffect, useRef, useState } from "react";
import { ChevronDown, Ruler } from "lucide-react";

export default function TikTokChartTools({
  showAverage,
  showMedian,
  useLogScale,
  show24HourMovingAverage,
  isHourlyChart = false,
  onAverageChange,
  onMedianChange,
  onLogChange,
  on24HourMovingAverageChange,
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => {
      if (!wrapperRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", closeOutside);
    return () => document.removeEventListener("pointerdown", closeOutside);
  }, [open]);
  return (
    <div ref={wrapperRef} style={{ position: "relative", flexShrink: 0 }} onKeyDown={(event) => { if (event.key === "Escape") setOpen(false); }}>
      <button type="button" aria-label="Chart tools" aria-expanded={open} onClick={() => setOpen((value) => !value)} style={{ display: "flex", alignItems: "center", gap: 8, width: 168, height: 30, padding: "0 10px", border: "1px solid rgba(255,255,255,0.16)", borderRadius: 8, background: "rgba(255,255,255,0.03)", color: "#eef3f7", fontFamily: "inherit", fontSize: 14, fontWeight: 500, cursor: "pointer" }}>
        <Ruler size={14} aria-hidden="true" />
        <span style={{ flex: 1, textAlign: "left" }}>Tools</span>
        <ChevronDown size={12} aria-hidden="true" />
      </button>
      {open && (
        <div aria-label="Chart tools options" style={{ position: "absolute", top: "calc(100% + 7px)", left: 0, width: 190, padding: 6, border: "1px solid rgba(255,255,255,0.16)", borderRadius: 8, background: "#0b0b0b", boxShadow: "0 18px 45px rgba(0,0,0,0.85)", zIndex: 1000 }}>
          {[
            { label: "Show Average", checked: showAverage, change: onAverageChange },
            { label: "Show Median", checked: showMedian, change: onMedianChange },
            ...(isHourlyChart ? [{
              label: "24-hour Moving Average",
              checked: show24HourMovingAverage,
              change: on24HourMovingAverageChange,
            }] : []),
            { label: "Log Scale", checked: useLogScale, change: onLogChange },
          ].map(({ label, checked, change }) => (
            <label key={label} style={{ display: "flex", alignItems: "center", gap: 9, minHeight: 32, padding: "0 8px", color: "#cfd8e3", fontSize: 14, fontWeight: 500, cursor: "pointer" }}>
              <input aria-label={label} type="checkbox" checked={checked} onChange={(event) => change(event.target.checked)} style={{ accentColor: "#3fa9f5" }} />
              {label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}